export { default as parallax } from './parallax'

export const throttle = function(fn, wait) {
  clearTimeout(throttle.timer)
  throttle.timer = setTimeout(function() {
    fn.apply()
  }, wait)
}

export const cookie = {
  set(sName, sValue, sExpires, spath, sdomain, secure) {
    let sCookie = sName + '=' + encodeURIComponent(sValue)
    const date = new Date()
    date.setTime(date.getTime() + 3600 * 24 * 1000 * 365)
    sExpires = sExpires || date.toGMTString()
    if (sExpires != null) sCookie += '; expires=' + sExpires
    if (spath != null) sCookie += '; path=' + spath
    if (sdomain != null) sCookie += '; domain=' + sdomain
    if (secure != null) sCookie += '; secure=' + secure
    document.cookie = sCookie
  },
  get(sName) {
    const aCookie = document.cookie.split('; ')
    for (var i = 0; i < aCookie.length; i++) {
      var aCrumb = aCookie[i].split('=')
      if (sName === aCrumb[0]) return decodeURIComponent(aCrumb[1])
    }
    return ''
  },
  remove(sName, spath, sdomain) {
    if (this.get(sName)) {
      document.cookie = sName + '=' +
        ((spath) ? ';path=' + spath : '') +
        ((sdomain) ? ';domain=' + sdomain : '') +
        ';expires=Thu, 01 Jan 1970 00:00:01 GMT'
    }
  }
}

export function IsPC() {
  var userAgentInfo = navigator.userAgent
  var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
  var flag = true
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break }
  }
  return flag
}
